import {
  AccessConfig,
  FeatureToggle,
  RouteAccess,
  User
} from 'vrlcm-gui-types';
import { accessConfigToAllowedAccessMap, Http } from 'vrlcm-gui-utils';
import { UiAssetApiUri } from './uri';

interface AssetsCache {
  accessConfig?: AccessConfig;
  routeAccess?: RouteAccess;
  geoData?: any;
  featureToggle?: FeatureToggle;
}

type CachedItem = keyof AssetsCache;

export class AssetsApi {
  // This should contain all the assets as it is static always and won't change
  private static assetsCache: AssetsCache = {};

  public static async getAccessConfig() {
    const { accessConfig } = AssetsApi.assetsCache;
    if (accessConfig) {
      return accessConfig;
    }

    const response = await Http.get<AccessConfig>(
      UiAssetApiUri.GET_ACCESS_CONFIG_URL
    );
    AssetsApi.assetsCache.accessConfig = response.data;
    return response.data;
  }

  public static async getAllowedAccessMap(user: User) {
    const accessConfig = await AssetsApi.getAccessConfig();
    return accessConfigToAllowedAccessMap(accessConfig, user);
  }

  public static async getRouteAccess() {
    const { routeAccess } = AssetsApi.assetsCache;
    if (routeAccess) {
      return routeAccess;
    }

    const response = await Http.get<RouteAccess>(
      UiAssetApiUri.GET_ROUTES_ACCESS_URL
    );
    AssetsApi.assetsCache.routeAccess = response.data;
    return response.data;
  }

  public static async getGeoData() {
    const { geoData } = AssetsApi.assetsCache;
    if (geoData) {
      return geoData;
    }

    const response = await Http.get(UiAssetApiUri.GET_GEO_DATA_URL);
    AssetsApi.assetsCache.geoData = response.data;
    return response.data;
  }

  public static clearCache() {
    AssetsApi.assetsCache = {};
  }

  public static clearCachedItem(item: CachedItem) {
    AssetsApi.assetsCache[item] = undefined;
  }

  public static async getFeatureToggle() {
    const { featureToggle } = AssetsApi.assetsCache;
    if (featureToggle) {
      return featureToggle;
    }

    const response = await Http.get<FeatureToggle>(
      UiAssetApiUri.GET_FEATURE_TOGGLE_URL
    );

    AssetsApi.assetsCache.featureToggle = response.data;
    return response.data;
  }
}
